import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    padding: 0,
  }),
);

export const TitleWrapper = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.m} 0`,
      `${defaultTheme.spacing.m} 0`,
      `30px 0`,
      `30px 0`,
    ],
    margin: '0 auto',
    '& > p': {
      fontSize: [
        defaultTheme.font.size.l,
        defaultTheme.font.size.l,
        defaultTheme.font.size.xl,
        defaultTheme.font.size.xl,
      ],
      fontWeight: 'bold',
      marginBottom: [
        defaultTheme.spacing.m,
        defaultTheme.spacing.m,
        '10px',
        '10px',
      ],
    },
  }),
);

export const ChargeMethodWrapper = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'left',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.s} 32px`,
      `${defaultTheme.spacing.s} 32px`,
      `${defaultTheme.spacing.s} 64px`,
      `${defaultTheme.spacing.s} 64px`,
    ],
    margin: '0 auto',
    '& button': {
      width: ['47%', '47%', '27%', '184px'],
      margin: ['4px', '4px', '16px', '16px'],
      borderWidth: '1px',
    },
  }),
);

export const ExternalLinkWrapper = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    display: 'grid',
    gridTemplateColumns: [
      'repeat(2, minmax(120px, 178px))',
      'repeat(2, minmax(120px, 178px))',
      'repeat(3, 178px)',
      'repeat(3, 178px)',
    ],
    gridGap: ['8px', '8px', '32px', '32px'],
    justifyContent: 'center',
    paddingTop: defaultTheme.spacing.xxl,
    paddingBottom: defaultTheme.spacing.xxl,
    paddingLeft: [defaultTheme.spacing.xxl, defaultTheme.spacing.xxl, '', ''],
    paddingRight: [defaultTheme.spacing.xxl, defaultTheme.spacing.xxl, '', ''],
    '& button': {
      borderWidth: '1px',
    },
  }),
);

export const NoteArea = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'left',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.m} 36px`,
      `${defaultTheme.spacing.m} 36px`,
      `${defaultTheme.spacing.xs} 20%`,
      `${defaultTheme.spacing.xs} 20%`,
    ],
    margin: '0 auto',
    '& > p': {
      color: defaultTheme.text.gray,
      fontSize: defaultTheme.font.size.xs,
    },
  }),
);

export const LinkButtonArea = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: `${defaultTheme.spacing.m} 20%`,
    '& > a': {
      fontSize: defaultTheme.font.size.s,
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
    '& > button': {
      textDecorationLine: 'underline',
    },
  }),
);

export const BannerArea = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: `${defaultTheme.spacing.xxl} 0`,
  }),
);

export const AppealWrapper = styled.div(() =>
  mq({
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    '& > span': {
      color: defaultTheme.text.error,
      fontSize: [
        defaultTheme.font.size.xs,
        defaultTheme.font.size.xs,
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
      ],
      fontWeight: 'bold',
    },
  }),
);
